import { Platform } from 'react-native'

import {
  NR_AUTH_SESSION_CUSTOM_EVENT,
  NR_AUTH_SESSION_PAGE_ACTION,
} from '../constants/authObservability.constants'

interface NewRelicBrowserAuthAgent {
  addPageAction?: (name: string, attributes?: Record<string, string | number | boolean>) => void
  recordCustomEvent?: (name: string, attributes?: Record<string, string | number | boolean>) => void
}

/** Client-safe NR Browser params — no full email, userId, or accountId. */
export interface ReportAuthSessionToNewRelicParams {
  authEvent: string
  authProviders: string[]
  primaryAuthProvider: string
  isAnonymous: boolean
  userIdPrefix?: string | null
  emailDomain?: string | null
  displayName?: string | null
}

function buildAuthSessionNrAttributes(
  params: ReportAuthSessionToNewRelicParams,
): Record<string, string | boolean> {
  const attrs: Record<string, string | boolean> = {
    authEvent: params.authEvent,
    authProviders: params.authProviders.join(',') || 'unknown',
    primaryAuthProvider: params.primaryAuthProvider,
    isAnonymous: params.isAnonymous,
  }
  if (params.userIdPrefix) attrs.userIdPrefix = params.userIdPrefix
  if (params.emailDomain) attrs.emailDomain = params.emailDomain
  if (params.displayName) attrs.displayName = params.displayName
  return attrs
}

/**
 * Reports auth provider + event to New Relic Browser (web only).
 * Client-safe attributes only — full PII is logged server-side (Pino → NR Logs).
 */
export function reportAuthSessionToNewRelic(params: ReportAuthSessionToNewRelicParams): void {
  if (Platform.OS !== 'web') return
  if (typeof window === 'undefined') return

  const attrs = buildAuthSessionNrAttributes(params)
  const nr = (window as Window & { newrelic?: NewRelicBrowserAuthAgent }).newrelic
  if (!nr) return

  nr.addPageAction?.(NR_AUTH_SESSION_PAGE_ACTION, attrs)
  nr.recordCustomEvent?.(NR_AUTH_SESSION_CUSTOM_EVENT, attrs)
}
